import React from "react";

import {
  Text,
  WhooshTextProps,
} from "@whoosh/design-system/src/components/primitive";

import { CaddyCartIcon } from "./icons/CaddyCartIcon";
import { CaddyIcon } from "./icons/CaddyIcon";
import { CartIcon } from "./icons/CartIcon";
import { FullCartIcon } from "./icons/FullCartIcon";
import { MotorizedPullCartIcon } from "./icons/MotorizedPullCartIcon";
import { PrivateCartIcon } from "./icons/PrivateCartIcon";
import { PullCartIcon } from "./icons/PullCartIcon";
import { SingleCartIcon } from "./icons/SingleCartIcon";
import { WalkingIcon } from "./icons/WalkingIcon";

export { WalkingIcon } from "./icons/WalkingIcon";
export { CartIcon } from "./icons/CartIcon";
export { PullCartIcon } from "./icons/PullCartIcon";
export { MotorizedPullCartIcon } from "./icons/MotorizedPullCartIcon";
export { CaddyIcon } from "./icons/CaddyIcon";
export { CaddyCartIcon } from "./icons/CaddyCartIcon";
export { FullCartIcon } from "./icons/FullCartIcon";
export { SingleCartIcon } from "./icons/SingleCartIcon";
export { PrivateCartIcon } from "./icons/PrivateCartIcon";
export { MixedIcon } from "./icons/MixedIcon";

type transportCodeOptions =
  | "CART"
  | "PULL_CART"
  | "WALK"
  | "CADDIE"
  | "CADDIE_CART"
  | "MOTOR_PULL_CART"
  | "SINGLE_CART"
  | "FULL_CART"
  | "PRIVATE_CART"
  | string;

export const GetTransportIconFromCode = (
  code: transportCodeOptions | null,
  textVariation: WhooshTextProps["variant"] = "mainSmallSemiBold"
) => {
  switch (code) {
    case "CART":
      return CartIcon;
    case "PULL_CART":
      return PullCartIcon;
    case "WALK":
      return WalkingIcon;
    case "CADDIE":
      return CaddyIcon;
    case "CADDIE_CART":
      return CaddyCartIcon;
    case "MOTOR_PULL_CART":
      return MotorizedPullCartIcon;
    case "SINGLE_CART":
      return SingleCartIcon;
    case "FULL_CART":
      return FullCartIcon;
    case "PRIVATE_CART":
      return PrivateCartIcon;
    default:
      return () => (
        <Text maxFontSizeMultiplier={2} variant={textVariation}>
          {code}
        </Text>
      );
  }
};

export * from "./icons/TeeSheetTransportationIcon";
